module.exports = __webpack_public_path__ + "img/CliEyeSet1.5ba34630.jpg";